// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wcX_","content":"ManualTimeModal_content__3w7mX"};